import classNames from "classnames";
import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { IconName } from "PFTheme/graphics/icons";
import NoProfilesIllustration from "PFTheme/graphics/illustrations/illustration-no-profiles.svg";
import { AriaRole, ReactElement } from "react";
import { useTranslation } from "react-i18next";

import css from "./empty_state.module.scss";

type EmptyStateProps = {
  illustration?: ReactElement<any>;
  title?: string;
  message?: string;
  buttonIcon?: IconName;
  buttonLabel?: string;
  className?: string;
  role?: AriaRole;
  onButtonClick?: VoidFunction;
  children?: ReactElement;
};

export const EmptyState = ({
  illustration,
  title,
  message,
  buttonLabel,
  className,
  role,
  onButtonClick,
  children
}: EmptyStateProps) => {
  const { t } = useTranslation("core", { keyPrefix: "components.emptyState" });

  return (
    <Stack gap="spacingLg" center role={role} className={classNames(css.emptyState, className)}>
      {illustration || <NoProfilesIllustration aria-hidden="true" focusable="false" />}
      {title && <Typography variant="h1">{title}</Typography>}
      {message && <Typography variant="h4">{message}</Typography>}
      {onButtonClick && <Button onClick={onButtonClick}>{buttonLabel || t("buttonLabel")}</Button>}
      {children}
    </Stack>
  );
};
